// Import dependencies
// import Cart from './components/cart'
import Accordion from './components/accordion'
import Addresses from './templates/customers/addresses'
import Animator from './components/animator'
import CartApi from './components/cart-api'
import CurrencySwitcher from './components/currency-switcher'
import Filter from './components/filter'
import Form from './components/form'
import GiftCard from './components/gift-card'
import Header from './components/header'
import HeroBanner from './components/hero-banner'
import ImageLazyLoader from './components/image-lazy-loader'
// import Instagram from './components/instagram'
import LanguageSwitcher from './components/language-switcher'
import Login from './templates/customers/login'
import MiniCart from './components/mini-cart'
import NewsletterPopup from './components/newsletter-popup'
import PhoneFormatting from './components/phone-formatting'
import Product from './components/product'
import PromoBar from './components/promo-bar'
import QuantityIncrementor from './components/quantity-incrementor'
import Recharge from './components/recharge'
import SlideshowButtons from './components/slideshow-buttons'
import SlideshowPagination from './components/slideshow-pagination'
import SlideshowProgress from './components/slideshow-progress'
import SlideshowScrollbar from './components/slideshow-scrollbar'
import SlideshowThumbnails from './components/slideshow-thumbnails.js'
import Video from './components/video'
import VideoLazyLoader from './components/video-lazy-loader'
import PredictiveSearch from './components/predictive-search'
import WhereToBuyPopup from './components/where-to-buy-popup.js'
import FormEmbeds from './components/form-embeds.js'
import OverlayingImages from './components/overlaying-images'
import InteractiveMap from './components/interactive-map.js'
import Founders from "./components/founders";
import SlideInAutoscroll from "./components/slide-in-autoscroll";

class Theme {
  /**
   * An object for storing application components
   *
   * @type {object}
   */
  components = {}

  /**
   * Create the application instance
   */
  constructor() {
    this.registerComponents()
    this.registerCSSOnLoadEvent()
  }

  /**
   * Register an onload event for CSS stylesheets (both sync and async)
   */
  registerCSSOnLoadEvent() {
    const stylesheets = document.styleSheets
    const promises = [...stylesheets].map(stylesheet => {
      return new Promise((resolve, reject) => {
        // Stylesheets embedded in style tags will not have a href, and will never
        // fire the load event
        if (stylesheet.href === null) {
          return resolve(stylesheet)
        }

        // Stylesheets from third-party domains cannot be parsed due to CORS restrictions
        const url = new URL(stylesheet.href)
        if (url.host !== window.location.host) {
          return resolve(stylesheet)
        }

        // Add an event listener for the load of event on the stylesheet's link
        if (stylesheet.ownerNode) {
          stylesheet.ownerNode.addEventListener('load', e => {
            resolve(stylesheet)
          })
        }

        try {
          // See if CSS Rules already exist within the stylesheet.
          // If they do, the stylesheet is already loaded and parsed, and we don't
          // need to rely on the load event
          if (stylesheet.cssRules && stylesheet.cssRules.length > 0) {
            return resolve(stylesheet)
          }
        } catch (error) {
          // InvalidAccessError is thrown if CSS has not yet finished parsing
          // If this is the case, we let the error slide and add the event listener,
          // but rethrow any other errors to catch legitimate bugs
          if (error.name !== 'InvalidAccessError') {
            throw error
          }
        }
      })
    })

    Promise.all(promises).then(() => {
      let evt

      if (typeof Event === 'function') {
        evt = new Event('css:load')
      } else {
        evt = document.createEvent('Event')
        evt.initEvent('css:load', true, true)
      }

      document.dispatchEvent(evt)
    })
  }

  /**
   * Register individual application components here
   */
  registerComponents() {
    this.components.imageLazyLoader = new ImageLazyLoader(
      'img[data-lazy-load-src], img[data-lazy-load-srcset], picture source[data-lazy-load-srcset]',
    )
    this.components.videoLazyLoader = new VideoLazyLoader(
      'video[data-lazy-load-src]',
    )

    this.components.form = new Form()
    this.components.filter = new Filter()
    this.components.cartApi = new CartApi()
    this.components.miniCart = new MiniCart()
    // this.components.cart = new Cart()
    //
    this.components.product = new Product()

    this.components.accordion = new Accordion()
    this.components.addresses = new Addresses()
    this.components.animator = new Animator('.animate-on-scroll')
    this.components.currencySwitcher = new CurrencySwitcher()
    this.components.giftCard = new GiftCard()
    this.components.header = new Header()
    this.components.heroBanner = new HeroBanner()
    // this.components.instagram = new Instagram()
    this.components.languageSwitcher = new LanguageSwitcher()
    this.components.login = new Login()
    this.components.newsletterPopup = new NewsletterPopup()
    this.components.phoneFormatting = new PhoneFormatting()
    this.components.promoBar = new PromoBar()
    this.components.quantityIncrementor = new QuantityIncrementor()
    this.components.recharge = new Recharge()
    this.components.slideshowButtons = new SlideshowButtons()
    this.components.slideshowPagination = new SlideshowPagination()
    this.components.slideshowProgress = new SlideshowProgress()
    this.components.slideshowScrollbar = new SlideshowScrollbar()
    this.components.slideshowThumbnails = new SlideshowThumbnails()
    this.components.video = new Video()
    this.components.predictiveSearch = new PredictiveSearch()
    this.components.whereToBuyPopup = new WhereToBuyPopup()
    this.components.formEmbeds = new FormEmbeds()
    this.components.overlayingImages = new OverlayingImages()
    this.components.interactiveMap = new InteractiveMap()
    this.components.founders = new Founders()
    this.components.slideInAutoscroll = new SlideInAutoscroll()
  }
}

window.app = new Theme()
document.addEventListener('cart:add', event => {
  console.log('Cart add event', event)
})
document.addEventListener('cart:remove', event => {
  console.log('Cart remove event', event)
})
document.addEventListener('cart:update', event => {
  console.log('Cart update event', event)
})
document.addEventListener('cart:error', event => {
  console.error('Cart error event', event)
  console.error(event.error)
})
document.addEventListener('cart:processing:start', event => {
  console.log('Cart processing start event', event)
})
document.addEventListener('cart:processing:end', event => {
  console.log('Cart processing end event', event)
})
document.addEventListener('cart:discount:apply', event => {
  console.log('Cart discount apply event', event)
})
document.addEventListener('cart:discount:remove', event => {
  console.log('Cart discount remove event', event)
})
